import { Box, Stack } from "@mui/material";
import { TopLeftBackButton } from "@src/appV2/redesign/components/TopLeftBackButton";
import { Title } from "@src/appV2/redesign/system/ui-components";

interface AuctionBottomSheetHeaderProps {
  title: string;
  onBack: () => void;
}

export function AuctionBottomSheetHeader(props: AuctionBottomSheetHeaderProps) {
  const { title, onBack } = props;

  return (
    <Stack direction="column" alignItems="center" spacing={6}>
      <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
        {onBack && (
          <TopLeftBackButton
            size="medium"
            iconType="chevron-left"
            variant="outlined"
            aria-label="Back"
            LinkComponent="button"
            onClick={onBack}
          />
        )}
      </Box>

      <Title variant="h2" component="h2" sx={{ textAlign: "center", textWrap: "balance" }}>
        {title}
      </Title>
    </Stack>
  );
}
